var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.789698 4.18531C2.05858 2.69352 4.61778 0.332031 8.17625 0.332031C11.7347 0.332031 14.2939 2.69352 15.5628 4.18531C16.4074 5.17828 16.4074 6.59824 15.5628 7.59122C14.2939 9.08301 11.7347 11.4445 8.17625 11.4445C4.61778 11.4445 2.05858 9.08301 0.789698 7.59122C-0.0548989 6.59824 -0.0548995 5.17828 0.789698 4.18531ZM8.17625 1.66553C5.22038 1.66553 3.00108 3.64361 1.80545 5.04928C1.38451 5.54418 1.38451 6.23235 1.80545 6.72724C3.00108 8.13292 5.22039 10.111 8.17625 10.111C11.1321 10.111 13.3514 8.13292 14.547 6.72724C14.968 6.23235 14.968 5.54418 14.547 5.04928C13.3514 3.64361 11.1321 1.66553 8.17625 1.66553Z",
    fill: "#696969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32301 2.56498C7.60761 2.47803 7.9295 2.41016 8.2839 2.41016C10.1126 2.41016 11.5951 3.89274 11.5951 5.7214C11.5951 7.55006 10.1126 9.03265 8.2839 9.03265C6.45524 9.03265 4.97266 7.55006 4.97266 5.7214C4.97266 5.36902 5.03934 5.04767 5.1273 4.76106C5.29314 4.17508 5.93697 2.96015 7.32301 2.56498ZM8.2839 3.74365C8.09915 3.74365 7.91175 3.77909 7.70755 3.84184L7.70027 3.84408L7.69293 3.84615C6.90274 4.06933 6.49888 4.80478 6.40954 5.12723L6.40691 5.13672L6.404 5.14613C6.34123 5.34918 6.30615 5.53658 6.30615 5.7214C6.30615 6.81359 7.19171 7.69915 8.2839 7.69915C9.37609 7.69915 10.2617 6.81359 10.2617 5.7214C10.2617 4.62921 9.37609 3.74365 8.2839 3.74365Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateEyeIcon);
export default __webpack_public_path__ + "static/media/template-eye-icon.649890604429122a09fe933e57765715.svg";
export { ForwardRef as ReactComponent };